"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92117],{

/***/ 991822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_COLOR_500 = {
  branding: "primary500",
  link: "link500",
  success: "success500",
  error: "error500",
  pending: "pending500"
};
const MAPPING_COLOR_600 = {
  branding: "primary600",
  link: "link600",
  success: "success600",
  error: "error600",
  pending: "pending600"
};
const MAPPING_COLOR_50 = {
  branding: "primary50",
  link: "link50",
  success: "success50",
  error: "error50",
  pending: "pending50"
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}` : "unset"};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
  var _b = _a, {
    variant = "branding",
    type = "primary",
    content,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "type",
    "content",
    "className"
  ]);
  const getBgColor = () => {
    if (type === "primary") {
      if (variant === "default")
        return "white";
      return MAPPING_COLOR_500[variant];
    }
    if (type === "secondary") {
      if (variant === "default")
        return "background";
      return MAPPING_COLOR_50[variant];
    }
    if (type === "ghost") {
      return "white";
    }
  };
  const getBorderColor = () => {
    if (type === "ghost") {
      if (variant === "default")
        return "border";
      return MAPPING_COLOR_600[variant];
    }
  };
  const getColor = () => {
    if (variant === "default")
      return "textPrimary";
    if (type === "primary")
      return "white";
    return MAPPING_COLOR_600[variant];
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    backgroundColor: getBgColor() || "",
    borderColor: getBorderColor(),
    className
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    color: getColor(),
    level: 3,
    weight: "medium",
    line: 1
  }, content));
};




/***/ }),

/***/ 925810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DownOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DownOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 8.5L12 15.5L19 8.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 994734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19 15.5L12 8.5L5 15.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 480219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ProductGrid; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(922859);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(917709);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductGrid = ({
  products,
  productsPerRow = 5,
  regionName,
  contactLink,
  type = "grid",
  hideCtaButton,
  itemsPerPage,
  className
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .F)();
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const page = router.query.page ? Number(router.query.page) : 1;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    isMobile,
    className
  }, products == null ? void 0 : products.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Grid, {
    isMobile,
    key: index,
    productsPerRow,
    type
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName,
      contentName: item.sku,
      target: "productDetail",
      index: itemsPerPage ? index + (page - 1) * itemsPerPage : index,
      payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
    }) : {},
    ctaTracking: regionName && contactLink ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName,
      contentName: "contactSale",
      target: contactLink,
      payload: JSON.stringify({ sku: item.sku })
    }) : {},
    type,
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, isMobile }) => `
display: flex;
flex-wrap: wrap;
column-gap: 2px;
place-content: flex-start space-between;
background: ${theme == null ? void 0 : theme.colors.background};
padding: 2px 0;
&::after{
  content: "";
  flex: auto;
}
${isMobile ? "padding: 5px;" : ""}
`);
const Grid = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ productsPerRow, type, isMobile }) => `
  background: white;
  margin-bottom: 2px;
  ${type === "grid" ? `width: calc(${100 / productsPerRow}% - 2px);` : "width: 100%;"}
  ${isMobile ? "border-radius: 8px;" : ""}
  }`);




/***/ }),

/***/ 591007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54230);




const isShowRetailPrice = (supplierRetailPrice, latestPrice) => {
  let newSupplierRetailPrice = supplierRetailPrice;
  let newLatestPrice = latestPrice;
  if (typeof supplierRetailPrice === "string") {
    newSupplierRetailPrice = supplierRetailPrice.replace(/[₫đ.]/g, "");
  }
  if (typeof latestPrice === "string") {
    newLatestPrice = latestPrice.replace(/[₫đ.]/g, "");
  }
  return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};
const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange,
  numberDisplayFormat
}) => {
  const formattedRetailPrice = typeof supplierRetailPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(supplierRetailPrice, numberDisplayFormat) : supplierRetailPrice;
  const formattedLatestPrice = typeof latestPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(latestPrice, numberDisplayFormat) : latestPrice;
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        className: "att-product-detail-latest-price",
        level: 2,
        color: textColor,
        weight: "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
        className: "att-product-detail-latest-price",
        level: 1,
        color: textColor
      }, formattedLatestPrice);
    }
    const formattedMinPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.min, numberDisplayFormat, false);
    const formattedMaxPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.max, numberDisplayFormat);
    return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
  }
  const showRetailPrice = supplierRetailPrice && isShowRetailPrice(supplierRetailPrice, latestPrice);
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductPriceWrapper, {
    align,
    className
  }, renderedLatestPrice(), (showRetailPrice || isShowDiscount) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiscount, null, showRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const StyledDiscount = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  height: 1rem;
`;
const StyledTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx)`
  word-break: break-all;
`;
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK)`
  word-break: break-all;
`;




/***/ }),

/***/ 875547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ok": function() { return /* binding */ SOURCE_VIDEO; },
/* harmony export */   "bM": function() { return /* binding */ defaultSlider; },
/* harmony export */   "n6": function() { return /* binding */ DEFAULT_NUMBER_DISPLAY_FORMAT; }
/* harmony export */ });
const defaultSlider = {
  perView: 5,
  perSwipe: "|",
  autoplay: 0
};
const DEFAULT_NUMBER_DISPLAY_FORMAT = {
  thousandSeparator: ".",
  decimalSeparator: ","
};
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});




/***/ }),

/***/ 54230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V2": function() { return /* binding */ numberFormatter; },
/* harmony export */   "kX": function() { return /* binding */ numberParser; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(875547);


const formatCurrency = (value, numberDisplayFormat, includeUnit = true) => {
  if (typeof value !== "number")
    return "";
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  const valueWithCurrency = currencyFormat.format(value);
  if (!!numberDisplayFormat) {
    return valueWithCurrency.replaceAll(".", numberDisplayFormat.thousandSeparator);
  } else {
    return valueWithCurrency;
  }
};
const numberFormatter = (value, numberDisplayFormat) => {
  const strValue = String(value);
  const [integerPart, decimalPart = ""] = strValue.split(".");
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, (numberDisplayFormat == null ? void 0 : numberDisplayFormat.thousandSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.thousandSeparator */ .n6.thousandSeparator) + (strValue.includes(".") ? `${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}${decimalPart}` : "");
};
const numberParser = (value, numberDisplayFormat) => {
  return (numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) === "." ? `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "") : `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "").replace(`${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}`, ".");
};




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 98643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProductGridSlot": function() { return /* binding */ ProductGridSlot; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./modules/page-builder/hooks/usePbProducts.tsx
var usePbProducts = __webpack_require__(746882);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductGrid/ProductGrid.es.js
var ProductGrid_es = __webpack_require__(480219);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ./components/LazyComponent.tsx
var LazyComponent = __webpack_require__(110413);
;// CONCATENATED MODULE: ./modules/page-builder/slots/product-grid/ProductGridDesktopSlot.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








const ProductGridDesktopSlot = (param)=>{
    let { collectionSlug , serverData  } = param;
    const { contactLink  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const [{ products , hasMore , loading  }, { onNextPage  }] = (0,usePbProducts/* useProductsWrapperInfinite */.X)(collectionSlug !== null && collectionSlug !== void 0 ? collectionSlug : "", {
        initialValue: serverData,
        limit: 40
    });
    return products ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        backgroundColor: "#f6f6f6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGrid_es/* ProductGrid */.e, {
                products: products,
                regionName: "forYouListProduct",
                contactLink: contactLink,
                productsPerRow: 5
            }),
            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                justify: "center",
                marginTop: "s16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_es/* Button */.z, {
                    backgroundColor: "#fff",
                    width: 340,
                    onClick: onNextPage,
                    variant: "white-ghost",
                    color: "#000000",
                    marginBottom: "s8",
                    disabled: loading,
                    children: [
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {}),
                        (0,i18n.t)("Xem th\xeam")
                    ]
                })
            })
        ]
    }) : null;
};
const Spinner = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  border: 3px solid ".concat(theme.colors.blue100, ";\n  border-top-color: ").concat(theme.colors.blue500, ";\n  border-radius: 50%;\n  width: 1.5em;\n  height: 1.5em;\n  margin: 0 0.5rem;\n  animation: spin 1s linear infinite;\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n");
});
const LazyProductGridDesktopSlot = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGridDesktopSlot, _objectSpread({}, props))
    });
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/product-grid/ProductGridMobileSlot.tsx
function ProductGridMobileSlot_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductGridMobileSlot_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductGridMobileSlot_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









const ProductGridMobileSlot = (param)=>{
    let { collectionSlug , serverData  } = param;
    const { contactLink  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const [{ products , hasMore , loading  }, { onNextPage  }] = (0,usePbProducts/* useProductsWrapperInfinite */.X)(collectionSlug !== null && collectionSlug !== void 0 ? collectionSlug : "", {
        initialValue: serverData,
        limit: 20
    });
    return products ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
        direction: "column",
        backgroundColor: "#f6f6f6",
        justify: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGrid_es/* ProductGrid */.e, {
                products: products,
                regionName: "forYouListProduct",
                contactLink: contactLink,
                productsPerRow: 2
            }),
            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                width: "100%",
                paddingLeft: "s8",
                paddingRight: "s8",
                marginTop: "s16",
                marginBottom: "s4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_es/* Button */.z, {
                    backgroundColor: "#fff",
                    block: true,
                    onClick: onNextPage,
                    variant: "white-ghost",
                    color: "#000000",
                    disabled: loading,
                    children: [
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {}),
                        (0,i18n.t)("Xem th\xeam")
                    ]
                })
            })
        ]
    }) : null;
};
const LazyProductGridMobileSlot = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGridMobileSlot, ProductGridMobileSlot_objectSpread({}, props))
    });
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/product-grid/index.tsx


const ProductGridSlot = {
    desktop: LazyProductGridDesktopSlot,
    mobile: LazyProductGridMobileSlot
};


/***/ })

}]);